import styled, { css } from 'styled-components';

export const StyledList = styled.div`
  background-color: ${({ theme }) => theme.COLORS.BASE};
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  line-height: 16px;
  max-height: 330px;
  width: 268px;
  padding: 18px 29px 24px;
  box-shadow: 0px 6px 24px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
`;

export const ListElement = styled.div`
  padding-bottom: 20px;
  cursor: pointer;

  &:last-child {
    padding-bottom: 0;
  }

  ${props =>
    props.isSelected &&
    css`
      font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
    `}
`;
